// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"537":"2036e205a1c93baf","850":"ec99d8e249cc3e76"}[chunkId] + ".js";
};